<template>
    <section id="lms-course" class="container">
        <div class="row course-info">
            <div class="description col-md-6 col-sm-12">
                <div class="category-title" v-text="category.title"></div>
                <div class="course-title my-3" v-text="data.title"></div>
                <div class="course-description" v-html="makeHTML(data.description)"></div>
                <div v-if="data.workload" class="course-workload" v-text="'Carga Horária: '+data.workload+'hs'"></div>
            </div>
            <div class="course-thumb col-md-6 col-sm-12">
                <div v-if="data.video_url" class="course-video mt-0 mt-sm-4" @click="togglePlay">
                    <video ref="courseVideo" class="video w-100 h-100" playsinline poster="">
                        <source :src="data.video_url" type="video/mp4">
                    </video>
                    <i class="bi bi-play-circle-fill"></i>
                </div>
                <div v-else-if="data.thumbnail" class="course-thumbnail">
                    <img class="thumbnail" :src="data.thumbnail" :alt="data.title">
                </div>

            </div>
        </div>


        <div class="row breadcrumb-actions mt-5">
            <nav aria-label="breadcrumb" class="col-sm-12 col-md-6">
                <ol class="breadcrumb">
                    <li class="breadcrumb-item"><span href="#" v-text="category.title" @click="goLibrary(category.id)"></span></li>
                    <li class="breadcrumb-item active"><span class="bi-chevron-right" v-if="category.title != ''"></span><span href="#" v-text="data.title"></span></li>
                </ol>
            </nav>
            <div class="actions-buttons col-md-6 col-sm-12 mx-0 d-flex justify-content-end gap-3">
                <!--        <button type="button" class="btn d-flex px-4 py-3">-->
                <!--          <i class="material-icons me-1">support_agent</i>-->
                <!--          Assistente-->
                <!--        </button>-->
                <!--        <button type="button" class="btn d-flex px-4 py-3">-->
                <!--          <span class="material-symbols-outlined me-1">recommend</span>-->
                <!--          Letz Indica-->
                <!--        </button>-->
                <button v-if="userCanBuy && !free" type="button" class="btn d-flex px-4 py-3" @click="toggleToCart()">
                    <span class="material-symbols-outlined me-1">shopping_cart</span>
                    <span v-if="!toggleCart">Adquirir Curso</span>
                    <span v-else-if="toggleCart && !getLms.courses_packages">Retirar do carrinho</span>
                </button>
                <button v-if="userCanBuy && free" type="button" class="btn d-flex px-4 py-3" @click="startCourse()">
                    <span class="material-symbols-outlined me-1">start</span>
                    <span>Iniciar Curso</span>
                </button>
            </div>
        </div>


        <div class="row accordion mt-5" id="accordionSections">
            <div class="accordion-item" :class="section.slug" v-for="(section, idxSection) in data.sections"
                 :key="idxSection">
                <div class="accordion-header" :id="`heading${section.slug}`">
                    <div class="accordion-group">
                        <div class="accordion-button collapsed justify-content-between" :class="section.slug" type="button"
                             data-bs-toggle="collapse"
                             :data-bs-target="`#collapse${section.slug}`" aria-expanded="false"
                             :aria-controls="`collapse${section.slug}`"
                             @click="getSectionLessons(section);">

                            <div class="info d-flex align-items-center">
                                <img class="section-thumb" :src="section.thumbnail" :alt="section.title">
                                <div class="title-subtitle d-flex flex-column">
                                    <span class="title">{{ section.title }}</span>
                                    <span class="description mt-2" :title="section.description">{{ section.description }}</span>
                                </div>
                            </div>

                            <div class="actions-section d-flex align-items-center gap-5">
                                <div v-if="section.credit_coins" class="points-value d-flex flex-column align-items-center">
                                    <svg width="28" height="28" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M17.6185 10.9523V13.8095C17.6185 15.0476 14.6337 16.6666 10.9518 16.6666C7.26992 16.6666 4.28516 15.0476 4.28516 13.8095V11.4285"
                                            stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                        <path
                                            d="M4.56445 11.6752C5.38826 12.7686 7.93588 13.7943 10.9511 13.7943C14.633 13.7943 17.6178 12.2648 17.6178 10.9505C17.6178 10.2124 16.6778 9.4038 15.2025 8.83618"
                                            stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                        <path
                                            d="M14.7611 6.19043V9.04757C14.7611 10.2857 11.7763 11.9047 8.0944 11.9047C4.4125 11.9047 1.42773 10.2857 1.42773 9.04757V6.19043"
                                            stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                        <path fill-rule="evenodd" clip-rule="evenodd"
                                              d="M8.0944 9.03236C11.7763 9.03236 14.7611 7.50284 14.7611 6.18855C14.7611 4.87331 11.7763 3.33331 8.0944 3.33331C4.4125 3.33331 1.42773 4.87331 1.42773 6.18855C1.42773 7.50284 4.4125 9.03236 8.0944 9.03236Z"
                                              stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                    </svg>
                                    <span>{{ section.credit_coins }}</span>
                                </div>
                                <!--                <i class="bi bi-suit-heart-fill" :class="{ 'selected': section.is_fav }" :data-id="section.id"-->
                                <!--                   data-object="section" @click="favoriteItem($event)"></i>-->
                                <i class="bi bi-chevron-down"></i>
                            </div>

                        </div>
                    </div>

                </div>
                <div :id="`collapse${section.slug}`" class="accordion-collapse collapse"
                     :aria-labelledby="`heading${section.slug}`" data-bs-parent="#accordionSections">
                    <div class="accordion-body p-0" :key="accordionBodyKey">
                        <div v-if="sectionsData[section.id] && sectionsData[section.id].lessons.length">
                            <ul class="px-0" style="margin-bottom: 0">
                                <li class="lesson d-flex align-items-center justify-content-between px-4 py-4"
                                    v-for="(lesson, idxLesson) in sectionsData[section.id].lessons"
                                    @click="openLesson(lesson, section.slug)" :key="idxLesson">
                                    <div class="lesson-finished d-flex align-items-center">
                    <span v-if="lesson.is_finished" class="material-symbols-outlined">
                      done
                    </span>
                                        <span v-else class="material-symbols-outlined">
                      play_circle
                    </span>
                                        <span class="title ms-3">{{ lesson.title }}</span>
                                    </div>


                                    <div v-if="lesson.credit_coins" class="points-value d-flex align-items-center"
                                         :class="{'finished ': lesson.is_finished}">
                                        <svg width="28" height="28" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                                            <path
                                                d="M17.6185 10.9523V13.8095C17.6185 15.0476 14.6337 16.6666 10.9518 16.6666C7.26992 16.6666 4.28516 15.0476 4.28516 13.8095V11.4285"
                                                stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                            <path
                                                d="M4.56445 11.6752C5.38826 12.7686 7.93588 13.7943 10.9511 13.7943C14.633 13.7943 17.6178 12.2648 17.6178 10.9505C17.6178 10.2124 16.6778 9.4038 15.2025 8.83618"
                                                stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                            <path
                                                d="M14.7611 6.19043V9.04757C14.7611 10.2857 11.7763 11.9047 8.0944 11.9047C4.4125 11.9047 1.42773 10.2857 1.42773 9.04757V6.19043"
                                                stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                            <path fill-rule="evenodd" clip-rule="evenodd"
                                                  d="M8.0944 9.03236C11.7763 9.03236 14.7611 7.50284 14.7611 6.18855C14.7611 4.87331 11.7763 3.33331 8.0944 3.33331C4.4125 3.33331 1.42773 4.87331 1.42773 6.18855C1.42773 7.50284 4.4125 9.03236 8.0944 9.03236Z"
                                                  stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                        </svg>
                                        <span class="ms-3">{{ lesson.credit_coins }}</span>
                                    </div>
                                </li>
                            </ul>
                        </div>

                        <div v-if="!sectionsData[section.id]" class="px-4 py-4">
                            <span>Carregando ...</span>
                        </div>

                        <div v-if="sectionsData[section.id] && sectionsData[section.id].lessons.length < 1">
                            <div class="working">
                                <div class="icon-wrapper">
                                    <svg width="25" height="28" viewBox="0 0 25 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M12.8485 28C12.0698 27.8379 11.516 27.3425 10.9805 26.7932C9.87738 25.6645 8.75088 24.5592 7.63314 23.4451C7.56008 23.372 7.48703 23.3077 7.38475 23.2076C7.20796 23.3961 7.04724 23.5817 6.87337 23.7526C5.82284 24.7798 4.34494 24.7834 3.29953 23.7526C2.55096 23.0172 1.80799 22.2772 1.07062 21.5325C0.0266691 20.4769 0.0252079 19.0033 1.07062 17.9477C2.56459 16.4464 4.08633 14.9729 5.55473 13.4504C7.84061 11.0842 9.29513 8.26794 9.9687 5.04914C9.97963 4.91955 9.94975 4.78978 9.88323 4.67802C8.99415 2.99776 10.2397 0.985834 12.1377 1.05085C12.7655 1.06543 13.3628 1.32438 13.8026 1.77263C16.8972 4.85847 19.9899 7.94552 23.0806 11.0338C23.8111 11.7643 24.0091 12.6571 23.6533 13.628C23.2976 14.5989 22.5692 15.1154 21.5559 15.2293C21.0708 15.2841 20.6186 15.1607 20.1796 14.9525C20.0392 14.8827 19.881 14.8572 19.7259 14.8794C17.5138 15.3353 15.4148 16.2273 13.5513 17.5035C13.5148 17.5291 13.4783 17.5583 13.414 17.6102L13.7208 17.9207C14.7889 19.0063 14.7932 20.4659 13.7266 21.5478C13.5608 21.7159 13.3745 21.8634 13.1612 22.0526C13.8187 22.6911 14.4492 23.2588 15.0248 23.879C15.2943 24.169 15.4894 24.5201 15.5932 24.9021C15.6971 25.2841 15.7066 25.6857 15.6211 26.0722C15.5355 26.4587 15.3573 26.8187 15.1019 27.1211C14.8465 27.4236 14.5215 27.6595 14.1547 27.8086C13.9633 27.8875 13.7595 27.935 13.5608 27.9971L12.8485 28ZM10.9491 17.44C13.1298 15.5608 15.711 14.2048 18.4957 13.4753L11.3589 6.35828C10.6283 9.1364 9.27135 11.7104 7.39206 13.8829L10.9491 17.44ZM6.23268 15.1249C6.17862 15.1753 6.1304 15.2176 6.08657 15.2622C4.81493 16.5299 3.54353 17.7992 2.27237 19.0698C1.81943 19.5228 1.8209 19.9677 2.27237 20.4221L4.38658 22.5253C4.8702 23.0067 5.29611 23.006 5.7812 22.5217C7.03384 21.2724 8.28576 20.0227 9.53695 18.7725C9.59977 18.7104 9.65749 18.6432 9.70351 18.5935L6.23268 15.1249ZM12.0946 2.61861L12.053 2.68509C11.8506 2.68638 11.6559 2.76283 11.5067 2.89958C11.3576 3.03634 11.2645 3.22364 11.2457 3.42513C11.2157 3.74511 11.3655 3.9767 11.5832 4.19367C14.6135 7.21327 17.6416 10.2343 20.6676 13.2568C20.7236 13.3168 20.7834 13.3732 20.8466 13.4256C20.9527 13.5093 21.078 13.5654 21.2111 13.5887C21.3443 13.612 21.4812 13.6019 21.6095 13.5592C21.7377 13.5166 21.8534 13.4427 21.9461 13.3443C22.0387 13.2458 22.1055 13.1259 22.1404 12.9953C22.2317 12.6549 22.1097 12.3773 21.8642 12.1325C20.3374 10.6145 18.8127 9.09443 17.2903 7.57246C15.7671 6.05218 14.2475 4.53191 12.7148 3.01603C12.5439 2.84727 12.3028 2.74938 12.0946 2.61861ZM9.74515 20.9291C9.34993 21.3236 8.97735 21.6961 8.59527 22.0768C8.64714 22.1315 8.70704 22.198 8.7706 22.2609C9.84207 23.3294 10.9123 24.398 11.9814 25.4665C12.2071 25.6915 12.4255 25.9246 12.6622 26.1386C12.7749 26.2423 12.9144 26.3122 13.0649 26.3405C13.2154 26.3688 13.3708 26.3542 13.5134 26.2985C13.656 26.2427 13.7801 26.1481 13.8715 26.0253C13.9629 25.9025 14.018 25.7564 14.0305 25.6038C14.059 25.3116 13.9232 25.0822 13.7186 24.8791C12.445 23.6129 11.1741 22.3466 9.90587 21.0803C9.85766 21.0262 9.79994 20.9795 9.74515 20.9291ZM12.0493 20.8816C13.2299 19.9224 13.0721 19.4154 12.0493 18.6395L10.8804 19.7441L11.9105 20.7501C11.9551 20.7976 12.0025 20.8392 12.0493 20.8816Z" fill="#6954D9"/>
                                        <path d="M23.3726 2.49922C23.2637 2.69135 23.1885 2.91344 23.0416 3.06905C22.5302 3.61111 21.9933 4.13419 21.4585 4.65653C21.1035 5.00354 20.6104 5.00792 20.2809 4.68575C19.9514 4.36358 19.9448 3.86315 20.2882 3.51176C20.8239 2.96433 21.3658 2.42324 21.9137 1.88848C22.0274 1.76664 22.1768 1.68392 22.3405 1.65216C22.5041 1.6204 22.6736 1.64124 22.8247 1.71169C23.13 1.83661 23.3178 2.13248 23.3726 2.49922Z" fill="#6954D9"/>
                                        <path d="M23.3463 8.20194C23.0724 8.20194 22.7984 8.20705 22.5245 8.20194C22.043 8.19171 21.6748 7.83082 21.6778 7.37861C21.6807 6.9264 22.043 6.57062 22.5325 6.56478C23.0621 6.5582 23.5918 6.55747 24.1214 6.56478C24.6131 6.57135 24.963 6.92056 24.9616 7.38592C24.9601 7.85127 24.6043 8.18952 24.1134 8.20121C23.8577 8.20632 23.602 8.20267 23.3463 8.20194Z" fill="#6954D9"/>
                                        <path d="M18.3874 1.64108C18.3874 1.91431 18.3933 2.18753 18.3874 2.46076C18.3898 2.67398 18.3086 2.87967 18.1614 3.03387C18.0141 3.18807 17.8123 3.27856 17.5992 3.286C17.3861 3.29344 17.1786 3.21724 17.0209 3.07369C16.8632 2.93013 16.7679 2.73061 16.7554 2.51774C16.7313 1.9333 16.7313 1.34886 16.7554 0.768079C16.7681 0.555717 16.8631 0.356683 17.0203 0.213317C17.1775 0.0699522 17.3844 -0.00642857 17.597 0.000424304C17.8096 0.00727718 18.0112 0.0968228 18.1588 0.250011C18.3064 0.4032 18.3885 0.607941 18.3874 0.820678C18.394 1.0939 18.3874 1.36713 18.3874 1.64108Z" fill="#6954D9"/>
                                        <path d="M7.1063 18.6412C7.00767 18.8194 6.93973 19.0247 6.80604 19.1701C6.4488 19.5595 6.06746 19.927 5.68757 20.2951C5.33106 20.6414 4.84087 20.648 4.50993 20.3251C4.17899 20.0022 4.17826 19.4952 4.53623 19.1307C4.91246 18.7464 5.29088 18.3636 5.68027 17.9925C5.94399 17.7419 6.2647 17.7002 6.59418 17.842C6.89151 17.9691 7.0705 18.281 7.1063 18.6412Z" fill="#6954D9"/>
                                    </svg>
                                </div>
                                <div class="text-wrapper">
                                    <h3>Disponível em Breve</h3>
                                    <p>Estamos preparando as aulas desse módulo.</p>
                                    <div class="clear"></div>
                                </div>
                                <div v-if="logo_" class="logo-wrapper">
                                    <img ref="logo" :src="logo_" />
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>


        </div>


        <link rel="stylesheet"
              href="https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:opsz,wght,FILL,GRAD@24,400,1,0"/>
    </section>
</template>

<script>
import {mapGetters} from "vuex";
import { gsap } from "gsap";
import $ from 'jquery';
let emitter = require('tiny-emitter/instance');
import { makeHTML } from "../../helper";

export default {
    name: 'LmsCourse',
    components: {},
    data() {
        return {
            logo_: null,
            categoryId: 0,
            category: {
                title: ""
            },
            data: [],
            courseVideo: null,
            sectionsData: {},
            accordionBodyKey: 0,
            userCanBuy: false,
            free: false
        }
    },
    beforeMount() {

        let root_ = this;
        let courseSelected = root_.getCourseSelected;
        root_.categoryId = root_.$route.params.category;
        root_.sectionsData = {};

        let payload = {
            "lmsId": root_.getLms.id,
            "courseId": courseSelected,
            "slug": root_.$route.params.courseSlug
        };

        let payload2 = {
            "slug": root_.$route.params.lmsSlug,
            "language": root_.$i18n.locale
        };

        root_.$store.dispatch("LMS/getListLMS", payload2)
            .then(() => {
                if (!document.body.classList.contains('lms')) {
                    document.body.classList.add('lms');
                }
            })
            .catch(error => {
                console.error(error)
            })
            .finally(() => {
                root_.$parent.wait(false);
                emitter.emit('lms-loaded::finished');
            });

        root_.$store.dispatch("LmsCourse/getCourseInfo", payload)
            .then(data => {

                root_.data = data.course;
                let registrationStart = root_.$moment(root_.data.registration_start);
                let registrationEnd = root_.$moment(root_.data.registration_end);
                if(root_.data.price === 0 ) {
                    root_.free = true;
                }

                if (!data.user_courses.includes(data.course.id)) {

                    if (registrationStart.isValid() && registrationEnd.isValid()) {
                        root_.userCanBuy = root_.$moment().isBetween(registrationStart, registrationEnd);

                    } else if (registrationStart.isValid()) {
                        root_.userCanBuy = root_.$moment().isAfter(registrationStart);

                    } else if (registrationEnd.isValid()) {
                        root_.userCanBuy = root_.$moment().isBefore(registrationEnd);
                    } else {
                        root_.userCanBuy = true;
                    }

                }

                root_.getCategory();

                root_.accordionBodyKey++;
            });


    },
    created() {
        this.logoHandler();
        this.$store.dispatch('LMS/enableIsLMS');
    },
    mounted() {
        // Adding accordeon colours
        $('.accordion-item').on('show.bs.collapse', function(e) {
            // Anima a cor de fundo para azul usando GSAP quando o painel é aberto
            gsap.to($(e.target).prev('.accordion-header'), {
                backgroundColor: '#000000', // ou qualquer cor que você escolher
                duration: 0.5 // duração da animação em segundos
            });
        });
    },
    methods: {
        makeHTML,
        startCourse() {
            let root_ = this;
            let payload = [];
            payload = this.data;
            payload["object"] = "course";
            payload["quantity"] = 1;
            emitter.emit('root::loader', true)
            root_.$store.dispatch("LmsCart/removeAllItemsFromCart").then(() => {
                root_.$store.dispatch("LmsCart/toggleItemToCart", payload).then(() => {

                    let payload = {
                        "gateway": "coins"
                    }
                    payload.voucher = root_.voucherInfo?.code ?? "";

                    root_.$store.dispatch("LmsCart/cartCheckout", payload).then(() => {
                        root_.$router.push({
                            name: "LmsLessonContent",
                            params: {
                                lmsSlug: root_.data.lms.slug,
                                courseSlug: root_.data.slug,
                                sectionSlug: root_.data.next_lesson.slug,
                                lessonSlug: root_.data.next_lesson.lesson_slug
                            },
                            query: {
                                lesson_id: root_.data.next_lesson.lesson_id,
                                section_id: root_.data.next_lesson.section_id,
                                course_id: root_.data.next_lesson.course_id
                            }
                        });
                    })
                })
            })
        },
        getCategory() {
            let root_ = this;
            if (root_.categoryId) {
                root_.category = root_.data.categories.filter(category => {
                    return category.id == root_.categoryId;
                });
                root_.category = root_.category[0];
            } else {
                root_.category = root_.data.categories[0] ?? {title: "Sem categoria"};
            }
        },

        togglePlay() {

            if (this.$refs.courseVideo.paused) {
                this.$refs.courseVideo.play();
            } else {
                this.$refs.courseVideo.pause();
            }

            let playIcon = document.querySelector(".course-thumb .bi-play-circle-fill");
            playIcon.classList.toggle("hidden");
        },

        getSectionLessons(section) {
            let root_ = this;

            // root_.sectionsData = root_.getSectionById;
            // if (!root_.sectionsData[section.id]?.lessons && root_.sectionsData[section.id]?.lessons?.length === undefined) {
            let payload = {
                //"slug": section.slug
                "id": section.id
            };

            root_.$store.dispatch("LmsCourse/getCourseSections", payload)
                .then((section) => {

                    // root_.sectionsData = root_.getSectionById;
                    root_.sectionsData[section.id] = section;
                    root_.accordionBodyKey++;
                })
            // } else {
            //   root_.accordionBodyKey++;
            // }

        },
        openLesson(lesson, sectionSlug) {
            let root_ = this;
            if(root_.data.view_order && !lesson.is_finished) {
                if(root_.data.next_lesson != null) {
                    if(root_.data.next_lesson.slug != sectionSlug || root_.data.next_lesson.lesson_slug != lesson.slug) {
                        let rightSection = root_.data.sections.filter(section => {
                            return section.slug == root_.data.next_lesson.slug;
                        });
                        root_.$swal({
                            title: 'Atenção!',
                            text: `Você precisa concluir a seção "${rightSection[0].title}"  para prosseguir.`,
                            icon: 'warning'
                        })
                    } else {
                        root_.$router.push({
                            name: "LmsLessonContent",
                            params: {
                                lmsSlug: this.getLms.slug,
                                courseSlug: this.data.slug,
                                sectionSlug: sectionSlug,
                                lessonSlug: lesson.slug
                            },
                            query: {
                                lesson_id: lesson.id,
                                section_id: lesson.section_id,
                                course_id: root_.getCourseData.id
                            }
                        });
                    }
                } else {
                    root_.$router.push({
                        name: "LmsLessonContent",
                        params: {
                            lmsSlug: this.getLms.slug,
                            courseSlug: this.data.slug,
                            sectionSlug: sectionSlug,
                            lessonSlug: lesson.slug
                        },
                        query: {
                            lesson_id: lesson.id,
                            section_id: lesson.section_id,
                            course_id: root_.getCourseData.id
                        }
                    });
                }
            } else {
                this.$router.push({
                    name: "LmsLessonContent",
                    params: {
                        lmsSlug: this.getLms.slug,
                        courseSlug: this.data.slug,
                        sectionSlug: sectionSlug,
                        lessonSlug: lesson.slug
                    },
                    query: {
                        lesson_id: lesson.id,
                        section_id: lesson.section_id,
                        course_id: root_.getCourseData.id
                    }
                });
            }
        },
        favoriteItem(e) {
            const element = e.currentTarget;
            const objectId = element.getAttribute("data-id");
            const objectData = element.getAttribute("data-object");

            let payload = {
                "object": objectData,
                "object_id": objectId
            }
            this.$store.dispatch("LMS/favoriteItem", payload)
                .then(response => {
                    this.data.sections.forEach(section => {
                        console.log('Sections foreach')
                        if (section.id == objectId) {
                            console.log('Set Fav to', !section.is_fav)
                            section.is_fav = !section.is_fav;
                            response;
                        }
                    })
                })
                .catch(error => {
                    console.log('ERROR WHEN FAVORITE SECTION', error)
                });
            e.currentTarget.classList.toggle("selected");
        },
        toggleToCart() {
            let root_ = this;
            let payload = [];


            if(root_.getLmsConfigs.cart && !root_.toggleCart) {
                window.location.replace(root_.getLmsConfigs.cart_url);
                return;
            }


            payload = this.data;
            payload["object"] = "course";
            payload["quantity"] = 1;

            root_.$store.dispatch("LmsCart/toggleItemToCart", payload)
                .then(data => {
                    root_.$router.push({
                        name: "LmsCheckout"
                    });

                    console.log("then toggleToCart: ", data);
                })
                .catch(error => {
                    console.error("catch toggleToCart: ", error);
                });
        },
        logoHandler() {
            this.logo_ = this.$parent.design.logo;
        },
        goLibrary(categoryId){
            console.log(categoryId);
            this.$router.push({
                name: 'LmsLibrary',
                params: {
                    categoryId: categoryId
                }
            });
        }
    },
    computed: {
        ...mapGetters('LmsCourse', [
            "getCourseData", "getSectionById"
        ]),
        ...mapGetters('LMS', [
            "getLms", "getCourseSelected", "getLmsConfigs"
        ]),
        ...mapGetters("LmsCart", [
            "getCart"
        ]),
        toggleCart() {
            let root_ = this;
            return root_.getCart.some(course => course.item.id === root_.data.id);
        },
        lms() {
            return this.$store.getters['LMS/getLms'];
        }

    },
}
</script>

<style scoped lang="scss">

#lms-course {
    margin-top: 6rem;
    margin-bottom: 50px; /* adjust footer */
    padding-top: 28px;
    padding-bottom: 28px;

    #accordionSections {
        margin-top: 1.5rem !important;

        .accordion-item {
            border: none;
            padding-left: 0;
            padding-right: 0;
            box-shadow: 0px 4px 5px 0px rgba(0, 0, 0, 0.09);

            &.opened {
                border-radius: 10px;
                border: 1px solid #F6F6F6;
            }

            .accordion-collapse.collapse.show {
                border-radius: 0px 0px 10px 10px;
                border: 1px solid #F6F6F6;
            }


        }


        .accordion-header {

            .accordion-group {

                position: relative;

                .accordion-button {
                    position: relative;

                    &:not(.collapsed) {
                        border-radius: 10px 10px 0 0;
                        background: var(--buttons_color_2nd);
                        box-shadow: none;

                        .bi-chevron-down {
                            transform: rotate(180deg);
                        }


                    }

                    &:after {
                        content: none; /* Remove a seta padrão */
                    }

                    .points-value {
                        border-radius: 20px;
                        border: 1px solid #B1B1B1;
                        padding: 18px 30px;
                        margin-right: 60px;

                        span {
                            color: #B1B1B1;
                            text-align: center;
                            font-family: "Open Sans";
                            font-size: 20px;
                            font-style: normal;
                            font-weight: 600;
                            line-height: normal;
                        }

                        &.completed {
                            svg {
                                fill: var(--buttons_color);
                            }
                        }

                        svg {
                            fill: #B1B1B1;
                        }


                    }

                }

                .bi-suit-heart-fill {
                    cursor: pointer;
                    font-size: 40px;
                    color: #B1B1B1;
                    top: 30%;
                    z-index: 5;
                    right: 80px;

                    &.selected {
                        color: #E82E2E;
                    }
                }

                .title-subtitle {

                    font-style: normal;
                    line-height: normal;
                    margin-left: 1.5rem;
                    max-width: 90%;
                    margin-right: 24px;


                    .title {
                        color: var(--buttons_color);
                        font-family: "Open Sans";
                        font-size: 18px;
                        font-style: normal;
                        font-weight: 700;
                    }

                    .description {
                        color: #706F6F;
                        font-family: "Open Sans";
                        font-size: 16px;
                        font-weight: 400;
                        overflow: hidden;
                        line-break: anywhere;
                        -webkit-line-clamp: 3;
                        -webkit-box-orient: vertical;
                        text-overflow: ellipsis;
                        display: -webkit-box;
                    }
                }
            }

            .section-thumb {
                height: 112px;
                width: 200px;
                flex-shrink: 0;
                object-fit: cover;
                object-position: center;
            }
        }

        .lesson {
            cursor: pointer;

            .material-symbols-outlined {
                color: var(--buttons_color);
                font-size: 32px;
            }

            .title {
                color: #706F6F;
                font-size: 16px;
                font-style: normal;
                font-weight: 400;
                line-height: normal;
            }

            .points-value {

                &.finished {
                    svg {
                        fill: var(--buttons_color);
                    }
                }
            }

            &:hover {
                background-color: #F6F6F6;
                transition: all 0.5s ease;
            }
        }

        .bi-chevron-down {
            color: var(--buttons_color);
            font-size: 25px;
            font-style: normal;
            line-height: normal;
            transition: all 0.5s ease;
        }

        .rotate-180 {
            //transform: rotate(180deg);

        }

    }


    .course-info {

        line-height: normal;
        font-style: normal;

        .category-title {
            color: #706F6F;
            font-family: "Open Sans", sans-serif;
            font-size: 16px;
            font-weight: 500;
            line-height: 1px;
            margin-top: 20px;
        }

        .course-title {
            color: var(--buttons_color);
            font-family: "Open Sans", sans-serif;
            font-size: 44px;
            font-style: normal;
            font-weight: 700;
            margin-top: 0 !important;
        }

        .course-description {
            color: #706F6F;
            font-family: "Open Sans", sans-serif;
            font-size: 16px;
            font-weight: 400;
            max-height: 300px;
            overflow: auto;
        }

        .course-workload {
            color: #706f6f;
            font-family: "Open Sans",sans-serif;
            font-size: 16px;
            font-style: normal;
            font-weight: 700;
            margin-top: 15px;
        }

        .play {
            display: inline-flex;
            padding: 18px 38px;
            justify-content: center;
            align-items: center;
            gap: 10px;
            border-radius: 30px;
            background: var(--buttons_color);
            cursor: pointer;
            transition: transform 0.3s ease;

            .bi-play-circle-fill {
                color: #FFF;
                font-size: 24px;
                font-style: normal;
                font-weight: 400;
                line-height: normal;
            }

            span {
                color: #FFF;
                font-family: "Open Sans", sans-serif;
                font-size: 20px;
                font-style: normal;
                font-weight: 700;
                line-height: normal;
            }

            &:hover {
                box-shadow: 0 0 10px 5px rgba(112, 111, 111, 0.1882352941);
                transition: 0.3s ease;
            }

            &:active {
                transform: translateY(2px);
                box-shadow: 0px 0px 3px rgba(0, 0, 0, 0.3);
            }
        }

        .course-video {
            position: relative;
            display: inline-block;
            border-radius: 30px;
            overflow: hidden;
            cursor: pointer;

            video {
                display: block;
            }

            .bi-play-circle-fill {
                position: absolute;
                top: 25%;
                left: 45%;
                font-size: 96px;

                color: #FFFFFF;
            }
        }

        .course-thumb {

            display: flex;
            justify-content: center;


            .course-thumbnail {
                img {
                    width: 100%;
                    border-radius: 30px;
                    object-fit: cover;
                    object-position: top center;
                    max-height: 430px;
                }
            }

        }

    }

    .hidden {
        display: none;
    }


    nav {
        .breadcrumb-item {

            cursor: pointer;
            color: #706F6F;
            font-family: "Open Sans";
            font-size: 24px;
            font-style: normal;
            font-weight: 400;
            line-height: normal;

            &.active {
                color: var(--buttons_color) !important;
                background-color: transparent;
                font-weight: 500;
                .bi-chevron-right {
                    color: #706F6F;
                    padding-right: 8px;
                    font-size: 16px;
                }
            }

            & + &::before, & + ::before {
                content: ""; /* Este é um exemplo de código Unicode para 'chevron right' */
            }

        }

    }

    .breadcrumb-actions {
        margin-top: 3.75rem !important;
        .actions-buttons {
            margin-top: 0;

            .btn {
                color: #706F6F;
                font-family: "Open Sans";
                font-size: 20px;
                font-style: normal;
                font-weight: 400;
                line-height: normal;

                border-radius: 30px;
                background: #FFFFFF;
                box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.15);


                .material-icons, .material-symbols-outlined {
                    color: var(--buttons_color) !important;
                }

            }

        }

    }


    @media (max-width: 480px) {

        .course-thumb {
            margin-top: 15px;
        }

        .actions-buttons {
            flex-direction: column;
            gap: 20px;

            .title-subtitle {
                margin-left: 0;
            }

        }

        #accordionSections {
            .accordion-header {
                .accordion-group {
                    .actions-section {
                        .points-value {
                            padding: 9px 15px;
                        }
                    }
                }
            }
        }

        #accordionSections {
            * {
                padding-left: 0;
            }
            .accordion-item {
                // margin-left: 5px;
            }
        }


    }

    @media (min-width: 768px) {


    }

    @media (min-width: 1400px) {

    }


}

#lms-course .working{
    padding: 28px;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 10px;
}
#lms-course .working .icon-wrapper{
    height: 48px;
    border-radius: 100%;
    border: 2px solid var(--buttons_color);
    display: flex;
    justify-content: center;
    float: left;
    align-items: center;
    flex: 0 0 48px;
}
#lms-course .working .text-wrapper{
    float: left;
    width: calc(100% - 160px);
}
#lms-course .working .text-wrapper h3{
    margin: 0;
    color: #706F6F;
    font-size: 18px;
    font-weight: 700;
    margin-bottom: 2px;
}
#lms-course .working .text-wrapper p{
    margin: 0;
    color: #706F6F;
    font-size: 16px;
    font-weight: 400;
}
#lms-course .working .logo-wrapper{
    float: left;
    flex: 0 0 100px;
}
#lms-course .working .logo-wrapper img{
    height: auto;
    width: 100%;
}
.clear{
    clear: both;
}
</style>

